import { createContext } from 'react';
//
import { AzureContextType } from '../../types';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as AzureContextType);
